import React from 'react';
import BaseParametroCrud from './BaseParametroCrud';

export default function Parentescos() {
    return (
        <BaseParametroCrud
            header={{
                title: 'Parentescos',
                idCabezaFamilia: '1',
                url: '/parametros',
                nombreurl: 'Parámetros',
                nombreform: 'Parentescos'
            }}
            formTitle="Formulario parentescos"
            loadUrl="/parametros/parentescos"
            saveUrl="/parametros/guardarparentesco"
            alertTitle="Guardar parentescos"
            defaultValues={{
                id: 0,
                parParentesco: '',
                parActivo: false
            }}
            mapRowToForm={(row) => ({
                id: row.id,
                parParentesco: row.parParentesco,
                parActivo: row.parActivo
            })}
            columns={[
                { key: 'id', title: 'Id' },
                { key: 'parParentesco', title: 'Parentesco' },
                {
                    key: 'parActivo',
                    title: 'Estado',
                    render: (row) => (row.parActivo ? 'Activo' : 'Inactivo')
                }
            ]}
            renderFormFields={({ register, errors }) => (
                <>
                    <div className="row">
                        <div className="col-md-3">
                            <div className="form-group">
                                <label htmlFor="parParentesco">Parentesco</label>
                                <input
                                    {...register('parParentesco', { required: true })}
                                    className="form-control"
                                    placeholder="Parentesco"
                                    id="parParentesco"
                                />
                                {errors.parParentesco && <p style={{ color: 'red' }}>Digitar dato</p>}
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3">
                            <div className="form-group">
                                <div className="custom-control custom-switch">
                                    <input
                                        type="checkbox"
                                        {...register('parActivo')}
                                        className="custom-control-input"
                                        id="SwitchEstado"
                                    />
                                    <label className="custom-control-label" htmlFor="SwitchEstado">Estado</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        />
    );
}